<template>
<SwitchButton v-model="checked">
  <template v-slot:icon.checked>
    <LockOpenIcon/>
  </template>
  <template v-slot:icon.unchecked>
    <LockClosedIcon/>
  </template>
</SwitchButton>
</template>

<script>
import SwitchButton from "@/components/buttons/templates/SwitchButton";
import LockOpenIcon from "@/components/icons/LockOpenIcon";
import LockClosedIcon from "@/components/icons/LockClosedIcon";
import {computed} from "@vue/composition-api";
export default {
  name: "SwitchButtonLock",
  components: {LockClosedIcon, LockOpenIcon, SwitchButton},
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {emit}){
    const checked = computed({
      get: () => props.value,
      set: (value) => {
        emit('input', value)
      }
    })
    return {checked}
  }
}
</script>

<style scoped>

</style>
